import { useState, useRef } from "react";
import { AppContext } from "./AppContext";

const AppContextProvider = ({ children }) => {
  const [entityName, setEntityName] = useState(null);
  const [totalPublications, setTotalPublications] = useState(null);
  const [percentIncrease, setPercentIncrease] = useState(null);
  const [filterByData, setFilterByData] = useState(null);
  const [filterBySearchParams, setFilterBySearchParams] = useState(null);
  const [selectedFilterBy, setSelectedFilterBy] = useState(null);
  const [selectedFilterByLabel, setSelectedFilterByLabel] = useState(null);
  const [filterByViaSearch, setFilterByViaSearch] = useState(false);
  const [filterByHasMore, setFilterByHasMore] = useState(false);
  const [filterByLoadingMore, setFilterByLoadingMore] = useState(false);
  const [filterByLoading, setFilterByLoading] = useState(false);
  const [filterByError, setFilterByError] = useState(null);
  const [metaInfo, setMetaInfo] = useState(null);
  const [maskedEntityShortName, setMaskedEntityShortName] = useState(null);

  // "Filter by" pagination (funders/publishers dropdown) can hold 1000s of
  // rows, so DashboardLayout fetches it a page at a time. The dropdown
  // (FilterSelect) triggers the next page on scroll, but it lives in a
  // different component than the fetch logic - a ref-backed callback lets
  // FilterSelect call "load the next page" without DashboardLayout's fetch
  // implementation needing to be lifted into context state.
  const filterByLoadMoreRef = useRef(() => {});
  const registerFilterByLoadMore = (fn) => {
    filterByLoadMoreRef.current = fn;
  };
  const loadMoreFilterByOptions = () => {
    filterByLoadMoreRef.current();
  };

  const changeEntityName = (name) => {
    setEntityName(name);
  };

  const changeTotalPublications = (total) => {
    setTotalPublications(total);
  };

  const changePercentIncrease = (percent) => {
    setPercentIncrease(percent);
  };

  const changeFilterByData = (data) => {
    setFilterByData(data);
  };

  const changeFilterBySearchParams = (params) => {
    setFilterBySearchParams(params);
  };

  const changeSelectedFilterBy = (value) => {
    setSelectedFilterBy(value);
  };

  const changeSelectedFilterByLabel = (value) => {
    setSelectedFilterByLabel(value);
  };

  const changeFilterByViaSearch = (value) => {
    setFilterByViaSearch(value);
  };

  const changeFilterByHasMore = (value) => {
    setFilterByHasMore(value);
  };

  const changeFilterByLoadingMore = (value) => {
    setFilterByLoadingMore(value);
  };

  const changeFilterByLoading = (value) => {
    setFilterByLoading(value);
  };

  const changeFilterByError = (value) => {
    setFilterByError(value);
  };

  const changeMetaInfo = (value) => {
    setMetaInfo(value);
  };

  const changeMaskedEntityShortName = (value) => {
    setMaskedEntityShortName(value);
  };

  //   const logout = () => {
  //     setUser(null);
  //   };

  return (
    <AppContext.Provider
      value={{
        entityName,
        changeEntityName,
        totalPublications,
        changeTotalPublications,
        percentIncrease,
        changePercentIncrease,
        filterByData,
        changeFilterByData,
        filterBySearchParams,
        changeFilterBySearchParams,
        selectedFilterBy,
        changeSelectedFilterBy,
        selectedFilterByLabel,
        changeSelectedFilterByLabel,
        filterByViaSearch,
        changeFilterByViaSearch,
        filterByHasMore,
        changeFilterByHasMore,
        filterByLoadingMore,
        changeFilterByLoadingMore,
        filterByLoading,
        changeFilterByLoading,
        filterByError,
        changeFilterByError,
        registerFilterByLoadMore,
        loadMoreFilterByOptions,
        metaInfo,
        changeMetaInfo,
        maskedEntityShortName,
        changeMaskedEntityShortName,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export default AppContextProvider;
